import { css } from "@emotion/react";

export const addStyles = css`
  margin-right: 12px;
`;
